import React from 'react';
import css from './Home.module.css';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
  Redirect
} from 'react-router-dom';

import Search from './Search';
import Upload from './Upload';
import Folder from './Folder';
import Edit from './Edit';
import Move from './Move';

import Notifications from '../components/Notifications';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';


import {
  Button,
  Dialog,
  Grid,
  CircularProgress,
} from '@material-ui/core';


class Home extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      session: null,
      user: null,
      search: '',
      searchSubmitted: false,
      pageLoaded: false,
      alertOpen: false,
      alertTitle: '',
      alertMessage: '',
      alertDismissable: true,
      alertCallback: null,
      notifications: [],
    };
  }

  componentDidMount = () => {
    window.addEventListener('pageshow', this.getSession);
  }

  componentWillUnmount = () => {
    window.removeEventListener('pageshow', this.getSession);
  }

  getSession = () => {
    fetch('/api/status', { cache: 'no-cache' })
    .then(res => res.json())
    .then(data => {
      this.setState({ session: data.session, user: data.session.username});
    })
    .catch(err => { 
      this.setState({ session: null, user: null });
    })
    .finally(() =>  this.setState({ pageLoaded: true }));
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    if(this.state.search !== this.state.searchDisplay)
      return;
    this.setState({searchSubmitted: true});
  }

  handleSearchUpdate = (e) => {
    this.setState({search: e.target.value, searchDisplay: e.target.value});
  }

  searchCallback = () => {
    this.setState({search: '', searchSubmitted: false});
  }

  isLoggedIn = () => {
    return Boolean(this.state.user);
  }

  redirectNotLoggedIn = () => {
    if(!this.state.user && this.state.pageLoaded)
      return <Redirect to="/" />
    else
      return null;
  }

  handleAlert = (title, message, dismissable=true, callback=null) => {
    if(!title)
      return this.setState({ alertOpen: false, alertCallback: null });
    this.setState({ alertOpen: true, alertTitle: title, alertMessage: message, alertDismissable: dismissable, alertCallback: callback });
  }

  handleAlertConfirm = (result) => () => {
    if(this.state.alertCallback)
      this.state.alertCallback(result);
  }

  handleAlertDismiss = () => {
    this.handleAlert();
  }

  handleSnackbar = (message, dismissable = true, duration = 6000 ) => {
    if(!message)
      return this.state({ snakbarOpen: false });
    this.setState({ snackbarOpen: true, snackbarDismissable: dismissable, snackbarDuration: duration });
  }

  addNotification = (noti) => {
    return new Promise((resolve, reject) => {
      let temp = {
        id: noti.id,
        title: noti.title,
        message: noti.message,
        status: noti.status || 'done',
        progress: noti.progress || null,
        time: new Date(),
      };
      this.setState({ notifications: [...this.state.notifications, temp]}, () => resolve(true));
    });
  }

  removeNotification = (id) => {
    return new Promise((resolve, reject) => {
      this.setState({ notifications: this.state.notifications.filter(item => item.id !== id) }, () => resolve(true));
    });
    
  }

  clearNotifications = () => {
    return new Promise((resolve, reject) => {
      this.setState({ notifications: [] }, () => resolve());
    });
  }

  clearNotificationsStatus = (status) => () => {
    return new Promise((resolve, reject) => {
      this.setState({ notifications: this.state.notifications.filter(item => item.status !== status) }, () => resolve(true))
    });
  }

  updateNotification = (noti) => {
    return new Promise((resolve, reject) => {
      let updates = JSON.parse(JSON.stringify(this.state.notifications));
      let index = updates.findIndex((item) => item.id === noti.id);
      let temp = updates[index];
      temp.title = noti.title || temp.title;
      temp.message = noti.message || temp.message;
      temp.status = noti.status || temp.status;
      temp.progress = noti.progress || temp.progress;
      this.setState({ notifications: updates }, () => resolve());
    });
  }

  getNotifications = () => {
    return this.state.notifications;
  }

  isSigningIn = () => {
    let params = new URLSearchParams(window.location.hash.substring(1));
    let token = params.get('access_token');
    return Boolean(token);
  }

  signOnError = () => {
    let params = new URLSearchParams(window.location.hash.substring(1));
    let err = params.get('error_description');
    if(this.state.user)
      return false;
    else if(err)
      return err;
  }


  // SAML Auth
  handleSamlLogin = () => {
    window.location.href = '/saml/login';
  }

  handleSamlLogout = () => {
    window.location.href = '/saml/logout';
  }

  render() {
    const notiActions = {
      add: this.addNotification,
      remove: this.removeNotification,
      clear: this.clearNotificationsStatus('done'),
      get: this.getNotifications,
      update: this.updateNotification,
    };

    return (
      <Router>
        <Navbar bg="light" expand="lg">
          <Navbar.Brand href="#home">Marketing File Share</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <NavLink className="nav-link" to="/">Home</NavLink>
              {this.isLoggedIn() ? (
                <React.Fragment>
                  <NavLink className="nav-link" to="/folders">Folders</NavLink>
                  <NavLink className="nav-link" to="/upload">Upload</NavLink>
                  <NavLink className="nav-link" to="/search">Search</NavLink>
                </React.Fragment>
              ) : null}
            </Nav>
            <Notifications notifications={this.state.notifications} notiActions={notiActions} />
          </Navbar.Collapse>
        </Navbar>
        <Switch>
          <Route path="/" exact={true}>
            <div className={css.spacer}></div>
            <Grid container direction="column" justifyContent="center" alignItems="center">
              { this.signOnError() ? (
                <React.Fragment>
                  <Grid item container direction="column" justifyContent="center" alignItems="center">
                    <h3>Login Error</h3>
                    <div>{this.signOnError()}</div>
                    <div>For assistance, please contact the system administrator.</div>
                    <br />
                  </Grid>
                  <Grid item><Button onClick={this.handleSamlLogin}>Sign In</Button></Grid>
                </React.Fragment>
              ) : this.isLoggedIn() ? (
                <React.Fragment>
                  <Grid item><h3>Hello, {this.state.user}</h3><br /></Grid>
                  <Grid item><Button onClick={this.handleSamlLogout}>Sign Out</Button></Grid>
                </React.Fragment>      
              ) : this.isSigningIn() ? (
                <React.Fragment>
                  <Grid item><h3>Signing In, Please Wait</h3><br /></Grid>
                  <Grid item><CircularProgress /></Grid>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Grid item><h3>Please sign in</h3><br /></Grid>
                  <Grid item><Button onClick={this.handleSamlLogin}>Sign In</Button></Grid>
                </React.Fragment>
              )}
            </Grid>

            {/* {this.state.searchSubmitted && <Redirect to={{
              pathname: '/search',
              search: this.state.search,
            }} />} */}
          </Route>
          <Route path="/search">
            <Search callback={this.searchCallback} alert={this.handleAlert} notiActions={notiActions} />
            {this.redirectNotLoggedIn()}
          </Route>
          <Route path="/upload">
            <Upload user={this.state.user} alert={this.handleAlert} notiActions={notiActions} />
            {this.redirectNotLoggedIn()}
          </Route>v
          <Route path="/folders">
            <Folder alert={this.handleAlert} notiActions={notiActions} />
            {this.redirectNotLoggedIn()}
          </Route>
          <Route path="/edit">
            <Edit alert={this.handleAlert} notiActions={notiActions} />
          </Route>
          <Route path="/move">
            <Move alert={this.handleAlert} notiActions={notiActions} />
          </Route>
        </Switch>

        <Dialog aria-labelledby="alert-dialog" open={this.state.alertOpen}>
          <div className={css.alert}>
            <div className={css.alertTitle}>{this.state.alertTitle}</div>
            <div className={css.alertMessage}>{this.state.alertMessage}</div>
            {this.state.alertCallback ? ( 
              <div className={css.alertButton}>
                <Button onClick={this.handleAlertConfirm(true)}>Confirm</Button>
                <Button onClick={this.handleAlertConfirm(false)}>Cancel</Button>
              </div>
            ) : this.state.alertDismissable ? (
              <div className={css.alertButton}>
                <Button onClick={this.handleAlertDismiss}>Dismiss</Button>
              </div>
            ) : null
            }
          </div>
        </Dialog>
      </Router>
    );
  }
}

export default Home;